export const API_ERROR_MESSAGES = {
  SURVEY_ALREADY_RESPONDED: 'survey already responded'
}

export const QUESTION_TYPES = {
  // TODO: Add question types here
}

export const SURVEY_UI = {
  OPTIONS_RANGE_COLORS: {
    NPS_METRIC: {
      RED: 7,
      YELLOW: 2,
      GREEN: 2
    }
  }
}
